module.exports = __webpack_public_path__ + "img/instr_2.705d22b9.svg";